import { ROUTES } from '@/constants/routes';

export interface AdminModuleDefinition {
  key: string;
  label: string;
  group: string;
  route: string;
}

export const ADMIN_MODULES: AdminModuleDefinition[] = [
  { key: 'dashboard', label: 'Dashboard', group: 'General', route: ROUTES.DASHBOARD },
  { key: 'orders', label: 'Orders', group: 'General', route: ROUTES.ORDERS },
  { key: 'customers', label: 'Customers', group: 'General', route: ROUTES.CUSTOMERS },
  { key: 'enquiries', label: 'Enquiries', group: 'General', route: ROUTES.ENQUIRIES },
  { key: 'contacts', label: 'Contact Us', group: 'General', route: ROUTES.CONTACTS },
  { key: 'notifications', label: 'Notifications', group: 'General', route: ROUTES.NOTIFICATIONS },
  { key: 'categories', label: 'Categories', group: 'Catalog', route: ROUTES.CATEGORIES },
  { key: 'subcategories', label: 'Subcategories', group: 'Catalog', route: ROUTES.SUBCATEGORIES },
  { key: 'brands', label: 'Brands', group: 'Catalog', route: ROUTES.BRANDS },
  { key: 'states', label: 'States', group: 'Catalog', route: ROUTES.STATES },
  { key: 'districts', label: 'Districts', group: 'Catalog', route: ROUTES.DISTRICTS },
  { key: 'assemblies', label: 'Assemblies', group: 'Catalog', route: ROUTES.ASSEMBLIES },
  { key: 'constituencies', label: 'Constituencies', group: 'Catalog', route: ROUTES.CONSTITUENCIES },
  { key: 'attributes', label: 'Attributes', group: 'Catalog', route: ROUTES.ATTRIBUTES },
  {
    key: 'attribute_values',
    label: 'Attribute Values',
    group: 'Catalog',
    route: ROUTES.ATTRIBUTE_VALUES,
  },
  { key: 'products', label: 'Products', group: 'Catalog', route: ROUTES.PRODUCTS },
  { key: 'inventory', label: 'Inventory', group: 'Catalog', route: ROUTES.INVENTORY },
  { key: 'reviews', label: 'Reviews', group: 'Catalog', route: ROUTES.REVIEWS },
  { key: 'banners', label: 'Banners', group: 'Content', route: ROUTES.BANNERS },
  { key: 'collections', label: 'Collections', group: 'Content', route: ROUTES.COLLECTIONS },
  { key: 'media', label: 'Media Manager', group: 'Content', route: ROUTES.MEDIA },
  { key: 'cms', label: 'CMS Manager', group: 'Content', route: ROUTES.CMS },
  { key: 'seo', label: 'SEO Manager', group: 'Content', route: ROUTES.SEO },
  {
    key: 'email_templates',
    label: 'Email Template Manager',
    group: 'Content',
    route: ROUTES.EMAIL_TEMPLATES,
  },
  { key: 'blogs', label: 'Blog Manager', group: 'Content', route: ROUTES.BLOGS },
  { key: 'coupons', label: 'Coupons', group: 'Sales', route: ROUTES.COUPONS },
  { key: 'reports', label: 'Reports', group: 'Sales', route: ROUTES.REPORTS },
  { key: 'users', label: 'User & Role Manager', group: 'Administration', route: ROUTES.USERS },
  { key: 'settings', label: 'Settings', group: 'Administration', route: ROUTES.SETTINGS },
];

export const ADMIN_MODULE_GROUPS = [...new Set(ADMIN_MODULES.map((module) => module.group))];

export const ROUTE_MODULE_MAP: Record<string, string> = ADMIN_MODULES.reduce(
  (acc, module) => {
    acc[module.route] = module.key;
    return acc;
  },
  {} as Record<string, string>,
);

// Parent menu groups map to module keys that grant access to any child route
export const MENU_GROUP_MODULES: Record<string, string[]> = {
  catalog: [
    'categories',
    'subcategories',
    'brands',
    'states',
    'districts',
    'assemblies',
    'constituencies',
    'attributes',
    'attribute_values',
    'products',
    'inventory',
    'reviews',
  ],
  content: ['banners', 'collections', 'media', 'cms', 'seo', 'email_templates', 'blogs'],
  sales: ['coupons', 'reports'],
};

export function getModuleKeyForPath(pathname: string): string | null {
  if (ROUTE_MODULE_MAP[pathname]) return ROUTE_MODULE_MAP[pathname];
  if (pathname.startsWith('/orders/')) return 'orders';
  if (pathname.startsWith('/customers/')) return 'customers';
  if (pathname.startsWith('/products/')) return 'products';
  if (pathname.startsWith('/coupons/')) return 'coupons';
  if (pathname.startsWith('/blogs/')) return 'blogs';
  if (pathname.startsWith('/users/')) return 'users';
  return null;
}
